export default __webpack_public_path__ + "static/media/programs_usto_meeting.d3b31169.svg";